module.exports = __webpack_public_path__ + "static/media/sastra-login-banner4.eeb876b5.jpg";